import Main from "./components/Main/Main";

const App = () => {
  return <Main />;
}

export default App;
